import React from 'react';
import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { Dropdown, DropdownProps } from '@qbe/ads-core';
import { FormDataType } from 'contexts/FormProvider';

type DropdownControllerProps<T extends FieldValues> = {
  control: Control<T, any>;
  name: string;
  label: string;
  capture?: boolean;
  optionList: DropdownProps['optionList'];
};
// & Omit<DropdownProps, 'helperText' | 'value' | 'label' | 'error' | 'id' | 'multiple'>;

export function DropdownController<T extends FieldValues>({
  control,
  name,
  label,
  capture = false,
  ...rest
}: DropdownControllerProps<T>) {
  return (
    <Controller
      name={name as Path<T>}
      control={control}
      render={({ field: { ref, ...field }, fieldState: { error } }) => (
        <Dropdown
          {...field}
          optionList={rest.optionList}
          id={field.name as string}
          error={!!error}
          label={label}
          value={field.value as string}
          inputProps={
            {
              ['data-track']: field.name,
              ['data-track-value']: capture ? 'capture' : 'mask',
              ['data-test']: field.name,
            } as any
          }
        />
      )}
    />
  );
}
